<script setup>
import { VaButton, VaCard, VaCardContent, VaCardTitle } from 'vuestic-ui'
import { computed, onMounted, ref } from 'vue'
import { doughnutConfig, lineOptions } from '../../components/va-charts/vaChartConfigs'
import { externalTooltipHandler } from '../../components/va-charts/external-tooltip'
import VaChart from '../../components/va-charts/VaChart.vue'
import { useAppStore } from '../../stores/appStore'
import { useCompanyStore } from '../../stores/companies'

// Geral Charts
// Geral Charts
// Geral Charts

const optionsDoughnut = {
  ...doughnutConfig,
  plugins: {
    ...doughnutConfig.plugins,
    tooltip: {
      enabled: false,
      position: 'nearest',
      external: externalTooltipHandler,
    },
  },
}

const optionsDoughnut2 = {
  ...doughnutConfig,
  cutout: '50%',
  plugins: {
    ...doughnutConfig.plugins,
    tooltip: {
      enabled: false,
      position: 'nearest',
      external: externalTooltipHandler,
    },
  },
}

// Geral Charts
// Geral Charts
// Geral Charts

// Saúde Física
// Saúde Física
// Saúde Física

const physicalChartData = computed(() => ({
  labels: ['Saudável', 'Precisa de atenção'],
  datasets: [
    {
      backgroundColor: ['rgb(245, 74, 0)', '#ECF0F1'],
      data: [75, 25],
    },
  ],
}))

// Saúde Física
// Saúde Física
// Saúde Física

// Saúde Mental
// Saúde Mental
// Saúde Mental

const menthalChartData = computed(() => ({
  labels: ['Saudável', 'Precisa de atenção'],
  datasets: [
    {
      backgroundColor: ['#BA00F3', '#ECF0F1'],
      data: [75, 25],
    },
  ],
}))

// Saúde Mental
// Saúde Mental
// Saúde Mental

// Risco Afastamento
// Risco Afastamento
// Risco Afastamento

const riskChartData = computed(() => ({
  labels: ['Com risco', 'Sem risco'],
  datasets: [
    {
      backgroundColor: ['#FF0000', '#ECF0F1'],
      data: [75, 25],
    },
  ],
}))

// Risco Afastamento
// Risco Afastamento
// Risco Afastamento

// Evolução
// Evolução
// Evolução

const evolutionChartData = computed(() => ({
  datasets: [
    {
      backgroundColor: ['#1B9C16', '#ECF0F1'],
      data: [25, 75],
    },
  ],
}))

// Evolução
// Evolução
// Evolução

// Serviços
// Serviços
// Serviços

const servicesChartData = computed(() => ({
  labels: ['Rotina de Treino', 'Dieta', 'Fisioterapia', 'Yoga', 'Personal Trainer'],
  datasets: [
    {
      backgroundColor: ['#FF5879', '#FF9538', '#FFC64C', '#42B8B8', '#2F98E8'],
      data: [25, 75, 32, 16, 42],
    },
  ],
}))

// Serviços
// Serviços
// Serviços

// Cadastro
// Cadastro
// Cadastro

const usersChartData = computed(() => ({
  labels: ['Cadastrado', 'Aguardando cadastro'],
  datasets: [
    {
      backgroundColor: ['rgb(245, 74, 0)', '#ECF0F1'],
      data: [75, 25],
    },
  ],
}))

// Cadastro
// Cadastro
// Cadastro

// Telemedicina
// Telemedicina
// Telemedicina

const meetChartData = computed(() => ({
  labels: [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ],
  datasets: [
    {
      label: 'Consultas',
      backgroundColor: ['#FF0000', '#ECF0F1'],
      data: [0, 1, 2, 7, 1, 1, 1, 2, 1, 1, 0, 0, 1, 3, 1, 3, 1, 5, 1, 1, 0, 1, 2, 0, 1, 2, 1, 2, 1, 1],
    },
  ],
}))

// Telemedicina
// Telemedicina
// Telemedicina

// Consultas presenciais
// Consultas presenciais
// Consultas presenciais

const realMeetChartData = computed(() => ({
  labels: [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ],
  datasets: [
    {
      label: 'Consultas',
      backgroundColor: ['#FF0000', '#ECF0F1'],
      data: [0, 1, 2, 7, 1, 1, 1, 2, 1, 1, 0, 0, 1, 3, 1, 3, 1, 5, 1, 1, 0, 1, 2, 0, 1, 2, 1, 2, 1, 1],
    },
  ],
}))

// Consultas presenciais
// Consultas presenciais
// Consultas presenciais

const companyStore = useCompanyStore()
const appStore = useAppStore()

const companiesOptions = computed(() => {
  if (!Array.isArray(companyStore.companies)) {
    return []
  }
  return companyStore.companies.map((company) => ({
    text: `${company.name} ${!company.active ? '(Inativo)' : ''}`,
    value: company.id,
  }))
})

const filters = ref({
  tenant_id: null,
  month: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
})

const monthNames = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

function formatFn(date) {
  const jsDate = new Date(date)
  return `${monthNames[jsDate.getMonth()]} - ${jsDate.getFullYear()}`
}

function formatDateValue(date) {
  if (!date) return ''
  return date.toISOString()
}

onMounted(async () => {
  await companyStore.getCompanies(true)
})
</script>

<template>
  <div>
    <div class="flex items-center gap-4 flex-wrap mb-4">
      <h1 class="page-title !mb-0">Relatórios</h1>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
      <div class="lg:col-span-4">
        <VaCard>
          <VaCardContent>
            <h5 class="font-bold text-xl mb-4">Filtros</h5>
            <form class="grid grid-cols-6 items-end gap-4" @submit.prevent>
              <div v-if="companyStore.companies.length > 0">
                <VaSelect
                  v-model="filters.tenant_id"
                  label="Usuários da Empresa"
                  track-by="text"
                  value-by="value"
                  :options="companiesOptions"
                  searchable
                  highlight-matched-text
                  clearable
                />
              </div>
              <div>
                <VaDateInput
                  v-model="filters.month"
                  type="month"
                  :month-names="['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']"
                  class="w-full"
                  label="Mês"
                  :format="formatFn"
                  :format-value="formatDateValue"
                />
              </div>
              <div>
                <VaButton :disabled="appStore.loading" type="submit" color="primary" class="w-full">
                  <span v-if="appStore.loading">Gerando...</span>
                  <span v-else>Gerar Relatório</span>
                </VaButton>
              </div>
            </form>
          </VaCardContent>
        </VaCard>
      </div>

      <VaCard>
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Saúde Física</h1>
        </VaCardTitle>
        <VaCardContent class="flex flex-row gap-1">
          <section class="w-1/2">
            <div class="text-2xl font-bold text-primary">75%</div>
            <p class="text-xs text-secondary">do seu time está fisicamente saudável</p>
            <div class="my-4 gap-2 flex flex-col">
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: 'rgb(245, 74, 0)' }"></span>
                <span class="text-secondary">Saudável</span>
              </div>
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#ECF0F1' }"></span>
                <span class="text-secondary">Precisa de atenção</span>
              </div>
            </div>
          </section>
          <div class="w-1/2 flex items-center h-full flex-1 lg:pl-16 pl-2 -mr-1">
            <VaChart
              :data="physicalChartData"
              class="chart chart--donut h-[90px] w-[90px]"
              type="doughnut"
              :options="optionsDoughnut"
            />
          </div>
        </VaCardContent>
      </VaCard>

      <VaCard>
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Saúde Mental</h1>
        </VaCardTitle>
        <VaCardContent class="flex flex-row gap-1">
          <section class="w-1/2">
            <div class="text-2xl font-bold text-[#BA00F3]">75%</div>
            <p class="text-xs text-secondary">do seu time está mentalmente saudável</p>
            <div class="my-4 gap-2 flex flex-col">
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#BA00F3' }"></span>
                <span class="text-secondary">Saudável</span>
              </div>
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#ECF0F1' }"></span>
                <span class="text-secondary">Precisa de atenção</span>
              </div>
            </div>
          </section>
          <div class="w-1/2 flex items-center h-full flex-1 lg:pl-16 pl-2 -mr-1">
            <VaChart
              :data="menthalChartData"
              class="chart chart--donut h-[90px] w-[90px]"
              type="doughnut"
              :options="optionsDoughnut"
            />
          </div>
        </VaCardContent>
      </VaCard>

      <VaCard>
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Risco de afastamento</h1>
        </VaCardTitle>
        <VaCardContent class="flex flex-row gap-1">
          <section class="w-1/2">
            <div class="text-2xl font-bold text-[#FF0000]">3</div>
            <p class="text-xs text-secondary">pessoas do seu time correm risco de afastamento</p>
            <div class="my-4 gap-2 flex flex-col">
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#FF0000' }"></span>
                <span class="text-secondary">Com risco</span>
              </div>
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#ECF0F1' }"></span>
                <span class="text-secondary">Sem risco</span>
              </div>
            </div>
          </section>
          <div class="w-1/2 flex items-center h-full flex-1 lg:pl-16 pl-2 -mr-1">
            <VaChart
              :data="riskChartData"
              class="chart chart--donut h-[90px] w-[90px]"
              type="doughnut"
              :options="optionsDoughnut"
            />
          </div>
        </VaCardContent>
      </VaCard>

      <VaCard>
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Evolução</h1>
        </VaCardTitle>
        <VaCardContent class="flex flex-row gap-1">
          <section class="w-1/2">
            <div class="text-2xl font-bold text-[#1B9C16]">25%</div>
            <p class="text-xs text-secondary">de evolução com relação ao mês passado</p>
          </section>
          <div class="w-1/2 flex items-center h-full flex-1 lg:pl-16 pl-2 -mr-1">
            <VaChart
              :data="evolutionChartData"
              class="chart chart--donut h-[90px] w-[90px]"
              type="doughnut"
              :options="optionsDoughnut"
            />
          </div>
        </VaCardContent>
      </VaCard>

      <VaCard class="lg:col-span-2">
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Telemedicina</h1>
        </VaCardTitle>
        <VaCardContent class="space-y-4">
          <section>
            <div class="text-2xl font-bold text-primary">48</div>
            <p class="text-xs whitespace-nowrap text-secondary">consultas este mês</p>
          </section>
          <div>
            <VaChart
              :data="meetChartData"
              class="chart chart--donut h-[90px] w-[90px]"
              type="line"
              :options="lineOptions"
            />
          </div>
        </VaCardContent>
      </VaCard>

      <VaCard class="lg:col-span-2">
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Consultas presenciais</h1>
        </VaCardTitle>
        <VaCardContent class="space-y-4">
          <section>
            <div class="text-2xl font-bold text-primary">48</div>
            <p class="text-xs whitespace-nowrap text-secondary">consultas este mês</p>
          </section>
          <div>
            <VaChart
              :data="realMeetChartData"
              class="chart chart--donut h-[90px] w-[90px]"
              type="line"
              :options="lineOptions"
            />
          </div>
        </VaCardContent>
      </VaCard>

      <VaCard class="lg:col-span-2">
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Período de uso</h1>
        </VaCardTitle>
        <VaCardContent class="space-y-4">
          <div class="flex flex-row gap-1">
            <section>
              <div class="text-2xl font-bold text-primary">Segunda</div>
              <p class="text-xs whitespace-nowrap text-secondary">é o dia da semana com mais consultas</p>
            </section>
          </div>
          <div>
            <VaChart
              :data="realMeetChartData"
              class="chart chart--donut h-[90px] w-[90px]"
              type="line"
              :options="lineOptions"
            />
          </div>
        </VaCardContent>
      </VaCard>

      <VaCard>
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Uso dos serviços</h1>
        </VaCardTitle>
        <VaCardContent class="flex flex-row gap-1">
          <section class="w-1/2">
            <div class="text-2xl font-bold text-primary">5</div>
            <p class="text-xs whitespace-nowrap text-secondary">serviços foram utilizados nestes mês</p>
            <div class="my-4 gap-2 flex flex-col">
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#FF5879' }"></span>
                <span class="text-secondary">Rotina de Treino</span>
              </div>
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#FF9538' }"></span>
                <span class="text-secondary">Dieta</span>
              </div>
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#FFC64C' }"></span>
                <span class="text-secondary">Fisioterapia</span>
              </div>
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#42B8B8' }"></span>
                <span class="text-secondary">Yoga</span>
              </div>
              <div class="flex items-center">
                <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#2F98E8' }"></span>
                <span class="text-secondary">Personal Trainer</span>
              </div>
            </div>
          </section>
          <div class="w-1/2 flex items-center h-full flex-1 lg:pl-16 pl-2 -mr-1">
            <VaChart
              :data="servicesChartData"
              class="chart chart--donut h-[200px] w-[200px]"
              type="doughnut"
              :options="optionsDoughnut2"
            />
          </div>
        </VaCardContent>
      </VaCard>

      <VaCard>
        <VaCardTitle class="pb-0!">
          <h1 class="card-title text-secondary font-bold uppercase">Engajamento</h1>
        </VaCardTitle>
        <VaCardContent class="space-y-2">
          <div class="flex flex-row gap-1">
            <section class="w-1/2">
              <div class="text-2xl font-bold text-primary">75%</div>
              <p class="text-xs whitespace-nowrap text-secondary">da sua base de funcionários está cadastrada</p>
              <div class="my-4 gap-2 flex flex-col">
                <div class="flex items-center">
                  <span class="inline-block size-4 mr-2 bg-primary"></span>
                  <span class="text-secondary">Cadastrado</span>
                </div>
                <div class="flex items-center">
                  <span class="inline-block size-4 mr-2" :style="{ backgroundColor: '#ECF0F1' }"></span>
                  <span class="text-secondary">Aguardando cadastro</span>
                </div>
              </div>
            </section>
            <div class="w-1/2 flex items-center h-full flex-1 lg:pl-16 pl-2 -mr-1">
              <VaChart
                :data="usersChartData"
                class="chart chart--donut h-[90px] w-[90px]"
                type="doughnut"
                :options="optionsDoughnut"
              />
            </div>
          </div>

          <p class="text-xs text-center text-secondary">
            Reenvie a mensagem de boas vindas para relembrar os usuários de finalizarem o seu cadastro.
          </p>

          <VaButton class="w-full" @click.prevent> Reenviar </VaButton>
        </VaCardContent>
      </VaCard>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
